<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="form-header">Periodo - Novo</span>
    </div>
    <div class="row">
      <div class="col-5" v-loading="isLoading">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="Ano" prop="field" v-bind:error="errors.ano ? errors.ano : '' ">
            <el-input v-model="form.ano" size="medium" autosize></el-input>
          </el-form-item>
          <el-form-item>
            <el-tree
              ref="listTree"
              :data="listTree"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="allIds"
              :props="defaultProps">
            </el-tree>

          </el-form-item>
          <div class="bottom clearfix">
            <el-button type="primary" style="float: right;margin: 20px" @click="salvar()"> Salvar</el-button>
            <el-button type="danger" style="float: right;margin: 20px" @click="cancelar()">Cancelar</el-button>
          </div>
        </el-form>
      </div>
    </div>

  </el-card>

</template>

<script>
  import ElCard from "element-ui/packages/card/src/main";
  import {mapActions, mapState ,mapGetters} from 'vuex'
  import ElForm from "element-ui/packages/form/src/form";
  import * as utils from '../../domain/utils'

  export default {
    components: {
      ElForm,
      ElCard
    },
    name: "periodo-create",
    data() {
      return {
        defaultProps : {
          children: 'children',
          label: 'nome'
        },
        errors: {},
        isLoading: false,
        form: {
          ano: (new Date()).getFullYear()
        }
      }
    },
    computed: {
      ...mapState('CentroCusto', ['list']),
      ...mapGetters('CentroCusto', ['listTree']),
      allIds()
      {
        return _.map(this.list, 'id')
      }
    },
    methods: {
      ...mapActions('Periodo', ['savePeriodo']),
      ...mapActions('CentroCusto', ['setList']),
      cancelar() {
        this.$router.push({name: 'periodo.index'})
      },
      async salvar() {
        try {

          this.isLoading = true
          this.errors = {}
          this.form['centros'] =   this.$refs.listTree.getCheckedKeys()
          await this.savePeriodo({...this.form})
          this.form.ano = ''
          this.$notify.success("Registro Salvo com sucesso!")
          this.$router.push({'name': 'periodo.index'})
        } catch (error) {

          this.errors = utils.error_form_transform(error)

          if (!this.errors) {
            utils.trataErrors(error)
          }
          console.log(error)
        } finally {
          this.isLoading = false
        }

      }
    },
    async mounted() {

      this.isLoading = true
      await this.setList()
      this.isLoading = false

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/features/Periodo/Create.vue